/**
 * Occurrence
 * @author Thacryba
 */
import {Resource, ResponseSerialize} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'

export class Occurrence extends Resource {
  idOccurrencePk: number = 0

  @ResponseSerialize(PanelUser)
  panelUser: PanelUser | null = null

  description: string | null = null
  active: boolean | null = false
  idExternalOccurrence: number | null = null
  isReturned: boolean | null = true

  get $id() {
    return this.idOccurrencePk
  }
  set $id(val) {
    this.idOccurrencePk = val
  }
  get $tag() {
    return String(this.description)
  }

  get idPanelUserFk() {
    if (!this.panelUser) return 0
    return this.panelUser.$id
  }
  set idPanelUserFk(val) {
    if (!this.panelUser) this.panelUser = new PanelUser()
    this.panelUser.$id = val
  }
}
